//src/components/apicalls/externalLessons.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const BASE = `${API_URL}/api/admin/external-lessons`;

export const getAllExternalLessons = (token, params = {}) =>
  axios.get(BASE, {
    params,
    headers: { 'Authorization': `token ${token}` }
  }).then(r => r.data);
  
export const createExternalLesson = (data, token) =>
  axios.post(BASE, data, { headers: { 'Authorization': `token ${token}` }}).then(r => r.data);

export const updateExternalLesson = (id, data, token) =>
  axios.put(`${BASE}/${id}`, data, { headers: { 'Authorization': `token ${token}` }}).then(r => r.data);

export const deleteExternalLesson = (id, token) =>
  axios.delete(`${BASE}/${id}`, { headers: { 'Authorization': `token ${token}` }}).then(r => r.data);

export const bulkCreateExternalLessons = (rows, token) =>
  axios.post(`${BASE}/bulk`, { rows }, { headers: { 'Authorization': `token ${token}` }}).then(r => r.data);
// src/components/apicalls/externalLessons.js
export const bulkDeleteExternalLessons = (ids, token) =>
  axios.delete(`${BASE}/bulk`, { data: { ids }, headers: { 'Authorization': `token ${token}` } }).then(r => r.data);

export const bulkUpdateExternalLessons = (ids, patch, token) =>
  axios.patch(`${BASE}/bulk`, { ids, patch }, { headers: { 'Authorization': `token ${token}` } }).then(r => r.data);

// Clicks
export const getAllExternalLessonClicks = (token, params = {}) =>
  axios.get(`${BASE}/clicks`, {
    params,
    headers: { 'Authorization': `token ${token}` }
  }).then(r => r.data);
